import { Actions } from 'flummox';

class AppStateActions extends Actions {
  is404(is404) {
    return is404;
  }

  openMenu() {
    return true;
  }

  openCityMenu() {
    return true;
  }

  openCityConfirm() {
    return true;
  }

  closeMenu() {
    return false;
  }

  closeCityMenu() {
    return false;
  }

  closeCityConfirm() {
    return false;
  }

  openForm() {
    return true;
  }

  closeForm() {
    return false;
  }
}

export default AppStateActions;



// WEBPACK FOOTER //
// ./src/actions/AppStateActions.js